/**
 * Como chamar uma conversa. Uma cadeia só, num lugar só.
 *
 * A ordem estava copiada em oito lugares e uma cópia divergia — o cartão de
 * permissão punha o palpite da IA na frente da escolha da pessoa. Cadeia
 * duplicada é cadeia que diverge; esta mora aqui e todo mundo delega.
 */

/** `C:\projetos\remoto` e `/home/eu/projetos/remoto` viram `projetos/remoto`. */
export function pastaCurta(cwd: string): string {
  const partes = cwd.split(/[\\/]+/).filter(Boolean);
  return partes.slice(-2).join('/') || cwd;
}

/** Texto que existe de verdade: só espaço em branco não conta como nome. */
function preenchido(valor: string | null | undefined): string | null {
  return typeof valor === 'string' && valor.trim().length > 0 ? valor.trim() : null;
}

export interface SessaoComTitulo {
  /** O que a PESSOA escolheu, pelo painel ou pela mestre. Vence tudo. */
  nome: string | null;
  /** O `ai-title` que o Claude escreve a cada turno. */
  tituloIa: string | null;
  /** O `name` que o próprio CLI se dá na máquina (`agenteatendimento-0b`). */
  nomeMaquina?: string | null;
  cwd: string;
}

/**
 * A escolha da pessoa vence sempre — é a regra da P2, e ela existe porque
 * quem renomeia está corrigindo justamente o que a máquina chutou.
 *
 * Depois vem o título da IA, que diz do que a conversa trata; depois o nome
 * que a máquina se deu, que ao menos desempata duas conversas na mesma pasta;
 * e por último a pasta, que é o que sempre existe.
 */
export function tituloDaSessao(sessao: SessaoComTitulo): string {
  return (
    preenchido(sessao.nome) ??
    preenchido(sessao.tituloIa) ??
    preenchido(sessao.nomeMaquina) ??
    pastaCurta(sessao.cwd)
  );
}
